/**
 * Primary action palette — buttons, primary CTAs, and focused interactive controls.
 * Aligned with DesignTest/DESIGN.md (near-black primary).
 */
export const BRAND_PRIMARY = {
  main: "#1C1B1F",
  dark: "#000000",
  darker: "#000000",
  light: "#3A383E",
  contrastText: "#FFFFFF",
  softLight: "rgba(28, 27, 31, 0.08)",
  softDark: "rgba(232, 232, 232, 0.12)",
  borderLight: "#CBC4D2",
  borderDark: "rgba(148, 143, 153, 0.45)",
  focusRing: "#1C1B1F",
};

/** @deprecated legacy green — use BRAND_PRIMARY for actions; keep for semantic “success” only */
export const LEGACY_GREEN = {
  main: "#4CAF50",
  dark: "#388E3C",
  hover: "#43A047",
};
